module.exports = __webpack_public_path__ + "img/iconBusyBike.8169f882.png";